/* KW 3.0 — product gallery.

   The track is a scroll-snap row of every image, not one frame whose src gets
   rewritten, so swiping is the browser's own scrolling: momentum, rubber
   banding, interruptible flicks, all free and all better than a carousel
   script would manage.

   Three things move the track, and they do NOT move it the same way:

     a thumbnail click  — smooth, because the customer asked for that picture
                          and the movement tells them where it sits.
     a variant change   — instant. The variant shots sit at the far end of the
                          gallery, so animating there means whooshing past ten
                          unrelated photos for over a second. The customer
                          flipped a switch in the buy box; they want to see the
                          result, not a tour.
     a swipe            — the customer's own finger. Nothing to do but keep the
                          thumbnails in step.

   Nothing here knows about variants. kw-variants.js announces which media it
   wants on a kw:media event and this file decides how to get there.
*/

(function () {
  function init() {
    var track = document.querySelector('[data-kw-track]');
    if (!track || track.dataset.kwGalReady === '1') return;
    track.dataset.kwGalReady = '1';

    var slides = [].slice.call(track.querySelectorAll('.kw-gal__slide'));
    var thumbs = [].slice.call(document.querySelectorAll('.kw-gal__thumb'));
    if (!slides.length) return;

    function mark(i) {
      thumbs.forEach(function (t, n) {
        t.setAttribute('aria-current', n === i ? 'true' : 'false');
      });
    }

    /* behavior on scrollTo beats the CSS scroll-behavior property, so the
       stylesheet can keep its smooth default for anything else. */
    function goTo(i, smooth) {
      if (i < 0 || i >= slides.length) return;
      var left = slides[i].offsetLeft - track.offsetLeft;
      if (track.scrollTo) {
        track.scrollTo({ left: left, behavior: smooth ? 'smooth' : 'auto' });
      } else {
        track.scrollLeft = left;
      }
      mark(i);
    }

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { goTo(i, true); });
    });

    /* Whichever slide is nearest the middle after a swipe wins the highlight,
       and its thumbnail is brought into view. Debounced because scroll fires
       far more often than the answer changes. */
    var tick;
    track.addEventListener('scroll', function () {
      clearTimeout(tick);
      tick = setTimeout(function () {
        var mid = track.scrollLeft + track.clientWidth / 2;
        var best = 0, bestD = Infinity;
        slides.forEach(function (s, i) {
          var c = s.offsetLeft - track.offsetLeft + s.clientWidth / 2;
          var d = Math.abs(c - mid);
          if (d < bestD) { bestD = d; best = i; }
        });
        mark(best);
        var t = thumbs[best];
        if (t && t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }, 90);
    }, { passive: true });

    document.addEventListener('kw:media', function (e) {
      var id = e.detail && e.detail.id;
      if (!id) return;
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].dataset.mediaId === String(id)) { goTo(i, false); return; }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();